import { TabPanels as ChakraTabPanels, TabPanelsProps } from '@chakra-ui/react';

export function TabPanels({ children, ...props }: TabPanelsProps): JSX.Element {
  return (
    <ChakraTabPanels
      width={'-moz-max-content'}
      borderWidth="1px"
      borderRadius="md"
      borderColor="gray.33"
      mt={12}
      {...props}
    >
      {children}
    </ChakraTabPanels>
  );
}
